/* Dropmagic Asset | Version: 1.0.0 */
// https://github.com/Vahan0799/infinite-marquee?tab=readme-ov-file
if (!customElements.get('dm-sticky-add-to-cart')) {
  customElements.define(
    'dm-sticky-add-to-cart',
    class DMStickyAddToCart extends HTMLElement {
      constructor() {
        super();
        // Initialize vanilla-marquee
        try{
         this.productHeroSection = document.querySelector('#product-hero-section');
         this.observer = null; // Initialize observer property

         if (this.productHeroSection) {
            this.initializeObserver();
         } else {
            console.warn('DMStickyAddToCart: #product-hero-section not found. Showing sticky bar.');
            // Show the sticky bar if the hero section is missing
            this.style.transform = 'none';
         }
        } catch (error) {
          console.error('Error initializing dm-sticky-add-to-cart:', error);
        }
      }

      initializeObserver() {
        const options = {
          root: null, // Use the viewport as the root
          rootMargin: '0px',
          threshold: 0 // Trigger when even 1px is visible/hidden
        };

        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
        this.observer.observe(this.productHeroSection);
      }

      handleIntersection(entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Product hero is in view, hide sticky bar
            this.style.transform = 'translateY(100%)';
          } else {
            // Product hero is out of view, show sticky bar
            this.style.transform = 'none';
          }
        });
      }

      disconnectedCallback() {
        // Clean up the observer when the element is removed
        if (this.observer && this.productHeroSection) {
          this.observer.unobserve(this.productHeroSection);
          this.observer.disconnect();
        }
      }
    }
  );
}